import { formatMoney } from "~/utils/formatMoney"
import baseUrl from "~/utils/admin/baseUrl"
import stripeIntentUrlFor from "~/utils/admin/stripeIntentUrlFor"
import moment from "moment"

const PaymentsCard = ({ paymentData, camp }) => {
  const {
    created_at,
    mode,
    kind,
    invoice_number,
    stripe_id,
    site_name,
    site_type,
    customer_full_name,
    reservation_start_date,
    duration,
    amount,
    application_fee,
    stripe_fee,
    tax_fee,
    net,
  } = paymentData

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-200">
      <div className="mb-3 pb-2 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">{customer_full_name}</h3>
        <div className="flex justify-between items-center mt-1">
          <p className="text-sm text-gray-500">
            {moment(created_at).format("YYYY-MM-DD HH:mm:ss")} • {kind == 'refund' ? 'Refund' : mode}
          </p>
          <p className="text-base font-medium text-gray-900">{formatMoney(net, camp?.currency)}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div>
          <p className="text-xs text-gray-500">Site</p>
          <p className="text-sm font-medium">{site_name}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Type</p>
          <p className="text-sm font-medium">{site_type}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Start Date</p>
          <p className="text-sm font-medium">
            {reservation_start_date ? moment(reservation_start_date).format("YYYY-MM-DD") : "-"}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Duration</p>
          <p className="text-sm font-medium">{duration || "-"}</p>
        </div>
      </div>

      <div className="mb-3">
        <div className="grid grid-cols-2 gap-2">
          <div>
            <p className="text-xs text-gray-500">Invoice</p>
            <p className="text-sm underline text-blue-600">
              <a href={`${baseUrl()}/i/${invoice_number}`} target="_blank" rel="noopener noreferrer">
                {invoice_number || "-"}
              </a>
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Stripe ID</p>
            <p className="text-sm underline text-blue-600">
              <a href={stripeIntentUrlFor(camp.stripe_account_id, stripe_id)} target="_blank" rel="noopener noreferrer">
                {stripe_id || "-"}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-x-4 gap-y-2 mb-4 pt-2 border-t border-gray-200">
        <div>
          <p className="text-xs text-gray-500">Amount</p>
          <p className="text-sm font-medium">{formatMoney(amount, camp?.currency)}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Taxes</p>
          <p className="text-sm font-medium">{formatMoney(tax_fee, camp?.currency)}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Application Fee</p>
          <p className="text-sm font-medium">{formatMoney(application_fee, camp?.currency)}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Stripe Fee</p>
          <p className="text-sm font-medium">{stripe_fee == '-' ? stripe_fee : formatMoney(stripe_fee, camp?.currency)}</p>
        </div>
      </div>

      <div className="flex justify-between items-center pt-2 border-t border-gray-200">
        <span className="text-sm text-gray-700">Net Amount</span>
        <span className="text-lg font-semibold text-gray-900">{formatMoney(net, camp?.currency)}</span>
      </div>
    </div>
  )
}

export default PaymentsCard
